import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { orderUtils } from "../Helpers/OderUtils";
import _ from "lodash";
import "../Styles/Order.css";
import "../Styles/NewOrder.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import CancelOrderWindow from "../containers/_CancelOrderWindow";
import CancelOrderItemsWindow from "../containers/_CancelOrderItemsWindow";
import ReturnOrderWindow from "../containers/_ReturnOrderWindow";
import ReturnOrderItemsWindow from "../containers/_ReturnOrderItemsWindow";
import InvoiceWindow from "../containers/_InvoiceWindow";
import EgiftCardsEmailWindow from "../containers/_EgiftCardsEmailWindow";
import locales from "../../../_constants/locales";
import OrderFetchErrorPage from "../containers/_OrderFetchErrorPage";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import OrderSummary from "./_OrderSummary";
import AddressInformation from "./_AddressInformation";
import LineItemsInformation from "./_LineItemsInformation";
import FulfillmentInformation from "./_FulfillmentInformation";
import StatusInformation from "./_StatusInformation";
import OrderRmaInformation from "./_OrderRmaInformation";
import OrderCancelledInformation from "./_OrderCancelledInformation";
import AuthorizedInformation from "./_AuthorizedInformation";
import OrderOptions from "./_OrderOptions";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/nl";

class Order extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancel_order_window_open: false,
            cancel_items_window_open: false,
            invoice_window_open: false,
            return_order_window_open: false,
            return_items_window_open: false,
            replace_window_open: false,
            replace_items_window_open: false,
            egiftcards_email_window_open: false
        };
    }

    getViewQueryParameters() {
        let search = this.props.location.search;

        if (search) {
            let params = search.substring(1, search.length).split("&");

            var store = [];

            for (let index = 0; index < params.length; index++) {
                let q = params[index].split("=");

                if (q[0].toUpperCase() === "STORE" && q[1] !== "") {
                    q[1]
                        .toUpperCase()
                        .split(",")
                        .forEach(e => {
                            if (this.props.store_list.indexOf(e) >= 0) {
                                store.push(e);
                            }
                        });
                } else if (q[0].toUpperCase() === "LANGUAGE" && q[1] !== "") {
                    if (this.props.language_list.indexOf(q[1].toUpperCase()) >= 0) {
                        this.props.setLanguage(q[1].toUpperCase());
                    }
                }
            }

            if (store.length > 0) {
                this.props.setStore(store);
            }
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.postMessageToParentWindow.bind(this));

        this.props.resetLanguage();
        this.props.resetStore();
        this.props.reset();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        this.getViewQueryParameters();

        this.postMessageToParentWindow();
        this.props.get(this.props.match.params.order_id);
        moment.locale(this.props.language);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.postMessageToParentWindow();

        if (prevProps.language !== this.props.language) {
            moment.locale(this.props.language);
        }

        if (this.props.language_list !== prevProps.language_list || this.props.store_list !== prevProps.store_list) {
            this.getViewQueryParameters();
        }

        if (this.props.egift_cards_email_loading === false && prevProps.egift_cards_email_loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            }
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);
        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    handleGoBackToSearch() {
        this.props.history.push(`/embedded/search?store=${this.props.store}&language=${this.props.language}`);
    }

    // Update Component to use handleEgiftCardsEmailDialog(true|false)
    // Update handle in to use something similar to handleActionClick
    // ------------------------------------------------- //
    handleCloseEgiftCardsEmailDialog() {
        this.setState({ egiftcards_email_window_open: false });
    }
    handleCloseInvoiceDialog() {
        this.setState({ invoice_window_open: false });
    }
    handleCloseCancelOrderItemsDialog() {
        this.setState({ cancel_items_window_open: false });
    }
    handleCloseCancelOrderDialog() {
        this.setState({ cancel_order_window_open: false });
    }
    handleCloseReturnOrderItemsDialog() {
        this.setState({ return_items_window_open: false });
    }
    handleCloseReturnOrderDialog() {
        this.setState({ return_order_window_open: false });
    }
    // ------------------------------------------------- //

    getBackgroundCss() {
        return this.state.cancel_order_window_open ||
            this.state.cancel_items_window_open ||
            this.state.invoice_window_open ||
            this.state.return_order_window_open ||
            this.state.return_items_window_open ||
            this.state.replace_items_window_open ||
            this.state.egiftcards_email_window_open
            ? " in-background"
            : "";
    }

    handleActionClick(action, status) {
        if (action === "SEND_EGIFTCARDS_EMAIL") {
            this.setState({ egiftcards_email_window_open: status });
        }
        if (action === "INVOICE") {
            this.setState({ invoice_window_open: status });
        }
        if (action === "REQUEST_ASSISTANCE") {
            window.open(locales[this.props.store[0]][this.props.language].MISC.HELP_LINK, "_blank");
        }
        if (action === "RETURN_ORDER_ITEMS") {
            this.setState({ return_items_window_open: status });
        }
        if (action === "RETURN_ORDER") {
            this.setState({ return_order_window_open: status });
        }
        if (action === "CANCEL_ORDER_ITEMS") {
            this.setState({ cancel_items_window_open: status });
        }
        if (action === "CANCEL_ORDER") {
            this.setState({ cancel_order_window_open: status });
        }
    }

    refreshOrder() {
        this.props.get(this.props.match.params.order_id);
        this.props.reset();
    }

    render() {
        let currentLanguage = (this.props.store[0] && this.props.language && locales[this.props.store[0]][this.props.language]) || {};
        let backgroundCss = this.getBackgroundCss();

        if (this.props.loading || this.props.language_list_loading || this.props.store_list_loading) {
            return (
                <section className={`flex layout horizontal center-justified${backgroundCss}`}>
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                </section>
            );
        }

        if (_.isEmpty(this.props.order) || this.props.fetching_error) {
            return (
                <section className={`flex layout horizontal center-justified${backgroundCss}`}>
                    <OrderFetchErrorPage />
                </section>
            );
        }

        let refundedItems = orderUtils.getRefundedItems(this.props.order);

        return (
            <section className={`flex ${backgroundCss}`}>
                <div className="order-main">
                    <div className="layout horizontal">
                        <button
                            className={`layout horizontal center justified back-to-search linked-text allow-focus`}
                            onClick={this.handleGoBackToSearch.bind(this)}
                        >
                            <NavigateBeforeIcon style={{ fontSize: "22px", height: "20px", width: "20px" }} />
                            {currentLanguage.ORDER_PAGE.HEADER_SECTION.BACK_TO_SEARCH}
                        </button>
                    </div>
                    <div className="status-bar-container">
                        <StatusInformation currentLanguage={currentLanguage} order={this.props.order} />
                    </div>
                    <div className="body-info-container">
                        <div className="order-items-container">
                            <AuthorizedInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <OrderCancelledInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <FulfillmentInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <LineItemsInformation
                                currentLanguage={currentLanguage}
                                order={this.props.order}
                                ordered
                                refundedItems={refundedItems}
                                egiftcardsOpen={this.handleActionClick.bind(this)}
                            />
                            <LineItemsInformation currentLanguage={currentLanguage} order={this.props.order} refunded refundedItems={refundedItems} />
                            <OrderRmaInformation currentLanguage={currentLanguage} order={this.props.order} />
                            <OrderOptions currentLanguage={currentLanguage} order={this.props.order} handleActionClick={this.handleActionClick.bind(this)} />
                        </div>
                        <div className="order-details-container">
                            <OrderSummary currentLanguage={currentLanguage} order={this.props.order} />
                            <AddressInformation currentLanguage={currentLanguage} address={this.props.order.billing_address} addressType="BILLING" />
                            <AddressInformation currentLanguage={currentLanguage} address={this.props.order.shipping_address} addressType="SHIPPING" />
                        </div>
                    </div>
                    <OrderOptions currentLanguage={currentLanguage} order={this.props.order} handleActionClick={this.handleActionClick.bind(this)} mobile />
                    <EgiftCardsEmailWindow
                        currentLanguage={currentLanguage}
                        open={this.state.egiftcards_email_window_open}
                        order_id={this.props.match.params.order_id}
                        handleCloseEgiftCardsEmailDialog={this.handleCloseEgiftCardsEmailDialog.bind(this)}
                    />
                    <InvoiceWindow
                        currentLanguage={currentLanguage}
                        open={this.state.invoice_window_open}
                        order_id={this.props.match.params.order_id}
                        handleCloseInvoiceDialog={this.handleCloseInvoiceDialog.bind(this)}
                    />
                    <CancelOrderItemsWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.cancel_items_window_open}
                        order_id={this.props.match.params.order_id}
                        handleClose={this.handleCloseCancelOrderItemsDialog.bind(this)}
                        refreshOrder={this.refreshOrder.bind(this)}
                        total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                    />
                    <CancelOrderWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.cancel_order_window_open}
                        order_id={this.props.match.params.order_id}
                        handleClose={this.handleCloseCancelOrderDialog.bind(this)}
                        refreshOrder={this.refreshOrder.bind(this)}
                        total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                    />
                    <ReturnOrderItemsWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.return_items_window_open}
                        order_id={this.props.match.params.order_id}
                        handleClose={this.handleCloseReturnOrderItemsDialog.bind(this)}
                        refreshOrder={this.refreshOrder.bind(this)}
                        total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                    />
                    <ReturnOrderWindow
                        currentLanguage={currentLanguage}
                        order={this.props.order}
                        open={this.state.return_order_window_open}
                        order_id={this.props.match.params.order_id}
                        handleClose={this.handleCloseReturnOrderDialog.bind(this)}
                        refreshOrder={this.refreshOrder.bind(this)}
                        total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                    />
                </div>
            </section>
        );
    }
}

export default withRouter(Order);



// WEBPACK FOOTER //
// ./src/views/Order/components/Order.jsx